import { render, staticRenderFns } from "./SelectDatesMenusPlansServices.vue?vue&type=template&id=cdd2135a&scoped=true&"
import script from "./SelectDatesMenusPlansServices.vue?vue&type=script&lang=js&"
export * from "./SelectDatesMenusPlansServices.vue?vue&type=script&lang=js&"
import style0 from "./SelectDatesMenusPlansServices.vue?vue&type=style&index=0&id=cdd2135a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd2135a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdd2135a')) {
      api.createRecord('cdd2135a', component.options)
    } else {
      api.reload('cdd2135a', component.options)
    }
    module.hot.accept("./SelectDatesMenusPlansServices.vue?vue&type=template&id=cdd2135a&scoped=true&", function () {
      api.rerender('cdd2135a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Divers/SelectDatesMenusPlansServices.vue"
export default component.exports